module.exports = __webpack_public_path__ + "img/pef_investment_preparing_icon.0b60da79.svg";